import React from 'react'
import styled from '@emotion/styled'
import { ContentResource as BaseContentResource } from '@jelly/components'
import Loadable from '@loadable/component'

import { BestPickTopCard } from '../Category/mega/BestPickTopCard'

//export directly
export { Link } from '@jelly/ui'
export { DatalotBanner } from '@jelly/components'
export const QtWidget = Loadable(() =>
	import(/* webpackChunkName: 'QtWidget' */ '@jelly/components').then(({ QtWidget }) => QtWidget)
)

export const RfqWidget = Loadable(() =>
	import(/* webpackChunkName: 'RfqWidget' */ '@jelly/components/lib/RfqWidget').then(({ RfqWidget }) => RfqWidget)
)

export const ContentResource = ({ resource, type }) => <BaseContentResource resource={resource} type={type} />

const BestPickContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	height: 100%;
	justify-content: center;
	margin: auto;
	width: 100%;

	> div {
		margin-bottom: 1rem;
		width: 100%;
	}

	${({ theme }) => theme.MQ.S} {
		> div {
			width: calc(50% - 1rem);
		}
	}
	${({ theme }) => theme.MQ.L} {
		width: 90%; // special case where we don't want 4 - 1 layout of the cards so we shrink the width so we go down to 3 - 2 layout
	}
	${({ theme }) => theme.MQ.XL} {
		width: 100%;

		flex-wrap: ${({ isLongFormTemplate }) => (isLongFormTemplate ? 'nowrap' : 'wrap')};

			> div {
				width: ${({ isLongFormTemplate }) => isLongFormTemplate && 'calc(1200px / 5 - 18px)'};
			}
		}
	}
`

interface Props {
	bestPicks: {
		bullets: string[]
		review: {
			canonical: string
			fullReview: string
			isReview: boolean
			title: string
			pricing: object
			review: {
				fullReview: string
			}
			thumbnail: {
				path: string
			}
		}
		tabTitle: string
	}[]
	isLongFormTemplate: boolean
}

export const BestPicks: React.FC<Props> = ({ bestPicks, template }) => {
	const MAX_NUMBER_OF_BESTPICKS = 5
	const firstFiveBestPicks = bestPicks?.slice(0, MAX_NUMBER_OF_BESTPICKS)

	const isLongFormTemplate = template === 'long_form'

	return (
		!!firstFiveBestPicks && (
			<BestPickContainer id="best-pick-ribbon" isLongFormTemplate={isLongFormTemplate}>
				{firstFiveBestPicks.map((bestPick, i) => {
					const {
						bullets,
						review,
						review: {
							canonical,
							isReview,
							review: { fullReview },
							title,
							pricing,
							thumbnail,
						},
						tabTitle,
					} = bestPick
					return (
						<BestPickTopCard
							key={`bestPick-${i}`}
							bullets={bullets}
							isJumpLink={false}
							tabTitle={tabTitle}
							review={{
								...review,
								reviewContent: isReview && fullReview,
								hasReviewEnabled: isReview && !!fullReview,
							}}
							reviewPath={canonical}
							pricing={{ ...pricing }}
							serviceName={title}
							thumbnail={thumbnail.path}
						/>
					)
				})}
			</BestPickContainer>
		)
	)
}
